import React from 'react';
import './index.css';
import Toast from '../common/Toast'
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
import Header from "../common/Header";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text:''
        };
    }

    componentDidMount() {
        document.title = '充值详情';
        this.setState({
            isactive: commonTools.searchPar().isactive
        });
    }

    showText(text){
        this.setState({
            text:text
        },()=>{
            setTimeout(()=>{
                this.setState({
                    text:"",
                })
            },2000)
        })
    }

    recharge(item){
        let back_url = document.location.origin;//首页
        let url = document.location.href;//当前页面
        let params = {
            'total_fee':parseInt(item*100),
            'back_url':back_url,
            'error_url':url,
            'smartpush': 1
        }
        util.ajax({
            url: "/zh/pay/wgpay",
            method:'post',
            isUser: true,
            isWechatId: true,
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {
                    document.location.href = res.result.data.url
                } else {
                    this.showText(res.result.status.msg);
                }
            }
        });
    }

    render() {
        return (
            <div className={`paybigbag`}>
                <Header />
                {
                    this.state.isactive == 1 ?
                    <div className="moneyBox">{/* 幸运大礼包 */}
                        <img src={require("../../../common/images/czhdIMG2.png")} className="hdIMG" />
                        <div className="tempBox">
                            <div className="tipInfo">充值19元 得1900金币+1900红包</div>
                            <a className="payBtn" onClick={()=>this.recharge(19)}>点击领取</a>
                        </div>
                    </div>
                    :
                    <div className="moneyBox">{/* 专享大礼包 */}
                        <img src={require("../../../common/images/czhdIMG1.png")} className="hdIMG" />
                        <div className="tempBox">
                            <div className="tipInfo">充值8.8元 得880金币+1200红包</div>
                            <a className="payBtn" onClick={()=>this.recharge(8.8)}>点击领取</a>
                        </div>
                    </div>
                }
                <div className="tipBox">
                    <div className="tipTitle">活动说明：（100金币/红包=1元）</div>
                    <div className="tipCon">1. 充值赠送的红包有效期为5天，过期自动失效；</div>
                    <div className="tipCon">2. 消费时优先扣除距离过期时间最近的红包；</div>
                    <div className="tipCon">3. 此礼包仅限领取一次；</div>
                    <div className="tipCon">4. 金币、红包为虚拟物品，一经充值不得退换。</div>
                </div>
                <Toast text={this.state.text}/>
            </div>
        );
    }
}